import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/common/PageHeader';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  const intro = t('legal.privacy.intro', { returnObjects: true });
  const sections = t('legal.privacy.sections', { returnObjects: true });
  const contact = t('legal.privacy.contact', { returnObjects: true });

  return (
    <div className="min-h-screen bg-primary-50 pb-12">
      <PageHeader
        title={t('legal.privacy.title')}
        subtitle={t('legal.privacy.subtitle')}
      />

      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8 mb-8">
          <div className="space-y-2 text-gray-700">
            <p className="text-sm text-gray-500">
              {t('legal.privacy.platform')}
            </p>
            <p className="text-sm text-gray-500">
              {t('legal.privacy.operator')}
            </p>
            <p className="text-sm text-gray-500">
              {t('legal.privacy.lastUpdated')}
            </p>
          </div>

          {Array.isArray(intro) && intro.length > 0 && (
            <div className="mt-6 space-y-3">
              {intro.map((p, idx) => (
                <p key={idx} className="text-gray-700 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
          )}
        </div>

        {Array.isArray(sections) && sections.length > 0 && (
          <div className="space-y-6">
            {sections.map((section, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8"
              >
                <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
                  {section.title}
                </h2>

                {Array.isArray(section.paragraphs) && section.paragraphs.length > 0 && (
                  <div className="space-y-3 mb-4">
                    {section.paragraphs.map((p, pIdx) => (
                      <p key={pIdx} className="text-gray-700 leading-relaxed">
                        {p}
                      </p>
                    ))}
                  </div>
                )}

                {Array.isArray(section.bullets) && section.bullets.length > 0 && (
                  <ul className="space-y-2">
                    {section.bullets.map((b, bIdx) => (
                      <li key={bIdx} className="flex items-start gap-3">
                        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0" />
                        <span className="text-gray-700">{b}</span>
                      </li>
                    ))}
                  </ul>
                )}

                {section.note && (
                  <div className="mt-4 p-4 bg-primary-50/60 border border-primary-100 rounded-lg text-sm text-gray-700">
                    {section.note}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl border border-primary-100 p-6 md:p-8 mt-8">
          <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
            {contact.title}
          </h2>
          <p className="text-gray-700 mb-3">{contact.text}</p>
          <a
            href={`mailto:${contact.email}`}
            className="text-primary-600 font-semibold hover:text-primary-700 transition"
          >
            {contact.email}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
